import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getAttendanceReportList = async () => {
  const response = await axios.get(
    `${base_url}attendancereport/allstaterole/vcvt`,
    config
  );
  return response.data;
};

const getVacantReportlist = async () => {
  const response = await axios.get(
    `${base_url}vacantpostion/getallvacantvtvc`,
    config
  );

  return response.data;
};

const getGuestLectureReportlist = async () => {
  const response = await axios.get(
    `${base_url}guestlecture/guestlectureCount`,
    config
  );

  return response.data;
};

const getIndustrialVisitReportlist = async () => {
  const response = await axios.get(
    `${base_url}industrialvisit/industrialvisitCount`,
    config
  );
  return response.data;
};

const getPendingInvoiceReportlist = async () => {
  const response = await axios.get(
    `${base_url}payment/pending/paymentall`,
    config
  );

  return response.data;
};

const getMouReportlist = async () => {
  const response = await axios.get(`${base_url}mou/AllMou/Reports`, config);
  return response.data;
};

const getImportantUpdatelist = async () => {
  const response = await axios.get(
    `${base_url}mou/Important/notification`,
    config
  );
  return response.data;
};

const getCurriculamProgresslist = async () => {
  const response = await axios.get(
    `${base_url}curriculam/allcurriculam/progress`,
    config
  );

  return response.data;
};

const getSalaryReportlist = async () => {
  const response = await axios.get(
    `${base_url}salryrecord/pendingSalary`,
    config
  );
  return response.data;
};

const getWeeklyVcReviewList = async () => {
  const response = await axios.get(
    `${base_url}performance/weekly-vc-review-report`,
    config
  );
  return response.data;
};

const dashboardService = {
  getAttendanceReportList,
  getVacantReportlist,
  getGuestLectureReportlist,
  getIndustrialVisitReportlist,
  getPendingInvoiceReportlist,
  getMouReportlist,
  getImportantUpdatelist,
  getCurriculamProgresslist,
  getSalaryReportlist,
  getWeeklyVcReviewList
};

export default dashboardService;
